import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import SweetAlert from 'react-bootstrap-sweetalert';


import axios from 'axios'
import { Recommendations, RecommendationSummary } from './Recommendations';


import { MultiSelect } from "react-multi-select-component";
import { API_BASE_PATH } from './Api';



function isValidEmail(email) {
    return /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email);
  }


  const optionsRecommendations = [
    { label: "Exceeded Predicted Quantity", value: "exQuantity" },
    { label: "Exceeded Predicted Amount", value: "exAmount" },
    { label: "No cross sell", value: "noCrossSell" },
    { label: "No up sell", value: "noUpSell" },
    { label: "No Focus product", value: "noFP" },
    { label: "No Mandated product", value: "noMandated" },
    { label: "No Must Order", value: "noMustOrder" },
    { label: "Other", value: "other" },


  ];

  const optionsCrossSell = [
    { label: "Exceeded Predicted Quantity", value: "exQuantity" },
    { label: "No Crosssell Item", value: "noCrossSell" },
    { label: "Already Purchased By Outlet", value: "invalidItem" },
    { label: "Other", value: "other" }
  ];

const Feedback = ({selectedItem,statusInfo,updater,loading}) => {

  const [showFailure,setFailure]=useState(false);
  const [showSuccess,setSuccess] = useState(false);
  var userInfo = localStorage.getItem("userInfo");
  if(userInfo){
    userInfo = JSON.parse(userInfo);
  }
  const loginId = userInfo?.loginId;
   
    const updateRecommendations = async () => new Promise((res, rej) => {
      loading(true)
      axios.post(API_BASE_PATH+`/objects/crossSell2/id/${statusInfo.id}?lob=${userInfo.accountId}`,{
        status:statusInfo.status,
        message:statusInfo.message,
        category:statusInfo.category,
        verifiedBy:loginId
      })
        .then(response => {
          const data = response.data;
          setSuccess(true);
          loading(false);
          res(data)
        })
        .catch(error => {
          console.log(error);
          setFailure(true);
          loading(false);
        })
    });

    async function handleSave(){

      //category,score,message,
      // const id=selectedItem.selectedItem;
      await updateRecommendations()

    }

    const handleMessage=(e)=>{
      const upd = Object.assign({},statusInfo);
      upd.message=e.target.value;
      updater(upd)
    }

    const handleSelect=(e)=>{

      const upd = Object.assign({},statusInfo);
      upd.status=e.target.value;
      updater(upd)
    }

    const handleCategory=(e)=>{
      const upd = Object.assign({},statusInfo);
      upd.category=e;
      updater(upd)
    }

    return (
        <>
        { showSuccess &&
        <SweetAlert success title="Success!" onConfirm={(e)=>{setSuccess(false)}} onCancel={(e)=>{setSuccess(false)}}>
  Successfully updated the status
</SweetAlert>
}
{ showFailure &&
        <SweetAlert error title="Failure!" onConfirm={(e)=>{setFailure(false)}} onCancel={(e)=>{setFailure(false)}}>
  Error while updating status
</SweetAlert>
}
        <div style={{height:"100%"}}>
        <div className="card shadow-sm border-0 px-3 rounded-2 mb-3 py-4 mx-auto mt-5 bg-light">
    <div className="card-header bg-transparent border-0 text-center text-uppercase"><h3></h3></div>
    <div className="card-body">
      <div>
        <div className="form-group">
    <p className="mb-0">Verification Status: {statusInfo?.status?"Verified":"Not Verified"}</p>
    <p className="mb-0">Verified By: {statusInfo?.verifiedBy}</p>

          <label className="mb-0">Compliance Score<span className="text-danger">*</span></label>
          <select className="form-control" placeholder="Name" value={statusInfo?.status||"5"} onChange={handleSelect}>
              <option>5</option>
              <option>4</option>
              <option>3</option>
              <option>2</option>
              <option>1</option>
          </select>
          <span style={{fontSize:"14px",color:"green"}}>(1-5 5 means fully compliant)</span>
        </div>

        <div className="form-group">
          <label className="mb-0">Non Compliance Category<span className="text-danger"></span></label>
          
             <MultiSelect
            options={statusInfo?.type=="crosssell"?optionsCrossSell:optionsRecommendations}
            value={statusInfo?.category||[]}
            onChange={handleCategory}
            labelledBy="Select"
          />
             
          
        </div>

        <div className="form-group">
          <label className="mb-0">Message<span className="text-danger"></span></label>
          
          <textarea name="message" type="text" className="form-control" placeholder="Message" value={statusInfo?.message||""} onChange={handleMessage}/>
             
          <br></br>
          <p className="text-center mb-0"><input type="button" className="btn btn-primary btn-lg w-100" style={{marginRight: "8px",
    borderColor: "rgb(40, 96, 144)",boxShadow: "rgb(0 0 0 / 8%) 0px 1px 1px inset, rgb(165 202 234) 0px 0px 8px"}} onClick={handleSave}  value="Update"/></p>
        </div>
        </div>
        </div>
        </div>
        </div>
      
      </>
    );
  };
  export default Feedback;
  
